module.exports = __webpack_public_path__ + "img/bg-yellow.34b00ce.png";